export const DRAG_TYPE_SCREENING_QUESTION = 'screening-question';
export const DRAG_TYPE_ANSWER = 'answer';
export const DRAG_TYPE_QUESTION = 'question';
export const DRAG_TYPE_GROUP = 'group';
export const DRAG_TYPE_GROUP_PROPERTY = 'group-property';
export const DRAG_TYPE_ATTRIBUTE_LEVEL = 'attribute-level';
// the following DRAG_TYPE_QUESTION_IN_GROUP is used when we want to allow
// dragging of a question only inside groups of same type
// (currently used for the Van Westendorp Newton/Miller pricing questions)
export const DRAG_TYPE_QUESTION_IN_GROUP = 'question-group-only';
export const DRAG_TYPE_MATRIX_ROW = 'matrix-row';
export const DRAG_TYPE_MATRIX_COLUMN = 'matrix-column';
export const DRAGGING_MATRIX_COLUMN_CLASS = 'is-dragging-matrix-column';
